import { Component, OnInit, Input } from '@angular/core';
import { CartDetails } from 'lms-api';
import { ShoppingCartService } from 'lms-api';

@Component({
  selector: 'app-cart-discount-upsell',
  templateUrl: './cart-discount-upsell.component.html',
  styleUrls: ['./cart-discount-upsell.component.scss']
})
export class CartDiscountUpsellComponent implements OnInit {
  public CartDetails$ = this.cartService.CartDetails;
  public coursesLeftToAdd: number;
  public nextSaveStep: number;

  public sizeWords = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];

  constructor(public cartService: ShoppingCartService) { 
    this.CartDetails$.subscribe(CartDetails => {
      let coursesTil = 0;
      if (CartDetails.Courses.size < 5) {
        this.coursesLeftToAdd = 5 - CartDetails.Courses.size;
        this.nextSaveStep = 51;
      } else if (CartDetails.Courses.size < 10) {
        this.coursesLeftToAdd = 10 - CartDetails.Courses.size;
        this.nextSaveStep = 100;
      }
    });
  }

  ngOnInit() {
    
  }

}
